import { useEffect, useState } from 'react';

export default function useLiveIvrAcknowledgment(binding, draft) {
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => {
    setConfirmed(false);
  }, [
    binding,
    draft.firstName,
    draft.lastName,
    draft.medicareId,
    draft.comment,
    draft.clinic,
    draft.files,
  ]);
  return [confirmed, setConfirmed];
}
